module.exports = __webpack_public_path__ + "static/Bol.com-b2ad85343b94312e3903e0de4ed096d2.svg";